import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import NoteActions from './NoteActions';

/**
 * NoteHeader Component
 * 
 * Displays the title input/display and action buttons for the note
 * 
 * @param {string} title - Current note title
 * @param {boolean} readOnly - Whether the note is in read-only mode
 * @param {boolean} isSaving - Whether a save operation is in progress
 * @param {Function} onTitleChange - Handler for title changes
 * @param {Function} onNewNote - Handler for creating a new note
 * @param {Function} onSaveNote - Handler for saving the current note
 * @param {Function} onShowPastNotes - Handler for showing past notes
 * @returns {JSX.Element} - The rendered component
 */
const NoteHeader = ({
  title,
  readOnly,
  isSaving,
  onTitleChange,
  onNewNote,
  onSaveNote,
  onShowPastNotes
}) => {
  return (
    <Box className='note-header' display="flex" justifyContent="space-between" alignItems="center" mb={1}>
      <Box className='note-title-container' flexGrow={1} mr={2}>
        {readOnly ? (
          <Typography variant='h6'>
            {title || 'Untitled Note'}
          </Typography>
        ) : (
          <input
            type='text'
            placeholder='Note title (optional)'
            className='note-title-input'
            value={title}
            onChange={(e) => onTitleChange(e.target.value)}
          />
        )}
      </Box>
      
      <NoteActions
        isSaving={isSaving}
        readOnly={readOnly}
        onNewNote={onNewNote}
        onSaveNote={onSaveNote}
        onShowPastNotes={onShowPastNotes}
      />
    </Box>
  );
};

NoteHeader.propTypes = {
  title: PropTypes.string,
  readOnly: PropTypes.bool,
  isSaving: PropTypes.bool,
  onTitleChange: PropTypes.func.isRequired,
  onNewNote: PropTypes.func.isRequired,
  onSaveNote: PropTypes.func.isRequired,
  onShowPastNotes: PropTypes.func.isRequired,
};

NoteHeader.defaultProps = {
  title: '',
  readOnly: false,
  isSaving: false,
};

export default NoteHeader;
